import React, {Component} from 'react';
import ProgressDialog from './ProgressDialog';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

class LoadDialog extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loading: false,
      open: false,
    };
  }

  onOpen = () => {
    this.setState({open:true});
  }

  onClose = () => {
    this.setState({open:false});
  }

  render() {
    const { open,onClick,color="inherit",value="loading" } = this.props;
    return (
      // <ProgressDialog open={status} loading={status} startLoading={start} stopLoading={stop} />
      <Backdrop
        // sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={open}
        onClick={onClick}
      >
        <CircularProgress color={color} value={value} />
      </Backdrop>
    );
  }
}

//export default ProgressDialog;

export default LoadDialog;
